export const constants = {
  SET: 'PRODUCT_FILTERS.SET',
  SET_MULTIPLE: 'PRODUCT_FILTERS.SET_MULTIPLE',
};

export const initialState = {
  swag: false,
  keg: true,
  bottle: true,
  nonDiminishable: false
};

export function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case constants.SET:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case constants.SET_MULTIPLE: {
      return {
        ...state,
        ...payload
      }
    }
    default:
      return state;
  }
}

export const actions = {
  setFilter: (key, value) => {
    return {
      type: constants.SET,
      payload: { key, value }
    };
  },
  setFilters: (payload) => {
    return {
      type: constants.SET_MULTIPLE,
      payload
    };
  }
}



// WEBPACK FOOTER //
// ./src/redux/productFilters.js